import Head from "next/head";
import { serverWrapper } from "utils";

import { Typography } from "components";

import StyleWrapper from "./index.style";

const Home = () => {
  return (
    <StyleWrapper>
      <Head>
        <title>AMX</title>
        <meta name="description" content="URM Meet - dashboard" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Typography
        tag="Display2"
        cardColor="neutrals"
        mode="element"
        value="American Express Component"
      />
    </StyleWrapper>
  );
};

const Auth = {
  authorized: false,
};

export const getServerSideProps = serverWrapper(Auth).getServerSideProps(() => {
  return {};
});

export default Home;
